import { hotjar } from "react-hotjar"

export function init() {
  setTimeout(() => hotjar.initialize(744953, 6), 4000)
}
